import { createSlice } from "@reduxjs/toolkit";

export interface IState {

  error: any,
};

export const initialState: IState = {

  error: {},
};

const SystemSlice = createSlice({
  name: "System",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

  },
});

export default SystemSlice.reducer;